import React from 'react';
import loadable from '@loadable/component';
import { withError } from '../../../shared/components/error-boundary';

export default withError(({ css }) => {
    if (!css) return null;
    if (css === 'omen-brand') {
        import('./mlp-omen-brand/mlp-omen-brand.less');
    }
    /* const CSS = loadable(() => import(`./${css}`));
    return <CSS css={css} />;*/
});
